import guide from './guide.vue'

export default guide